import { useCallback } from "react";

import { Label, Select } from "@skilitics/designer-ui-components";

import { useLocaleOptions } from "../../../l10n/useLocaleOptions.ts";
import type { localeConditionBuilder } from "./localeConditionBuilder";

export const LocaleConditionEditor: typeof localeConditionBuilder.views.edit = ({
  config: { locale },
  spec: { title },
  onConfigChange,
}) => {
  const options = useLocaleOptions();

  const handleSelectedOptionChange: NonNullable<Parameters<typeof Select>[0]["onSelectedOptionChange"]> = useCallback(
    (option) => onConfigChange({ locale: option.value }),
    [onConfigChange],
  );

  return (
    <div>
      <Label>{title}</Label>
      <Select options={options} value={locale ?? ""} onSelectedOptionChange={handleSelectedOptionChange} />
    </div>
  );
};
